module.exports = __webpack_public_path__ + "media/images/author/author-9-6bf3b01bd04441370ddf68246f1ec5e3.jpg";